
export class ErrorModal {
  static show(VueComponent, text) {
    VueComponent.$modal.show({
      template: `
            <div class="alert alert-danger" style="margin: 0;">
                <div class="popup-window__close popup-window-close" v-on:click="$emit('close')"><span class="icon-close"></span></div>
                <p>{{ error }}</p>
            </div>`,
      props: ['error']
    }, {
      error: text
    }, {
      height: 'auto',
      adaptive: true
    });
  }
}
